import { inject, Injectable } from '@angular/core';
import type { CanActivate, GuardResult, MaybeAsync } from '@angular/router';
import { Router } from '@angular/router';

import { environment } from '@rpgc-ai/environments';

@Injectable({ providedIn: 'root' })
export class DevelopEnvironmentGuard implements CanActivate {
  // Injections
  readonly #router = inject(Router);

  // Methods
  canActivate(): MaybeAsync<GuardResult> {
    return environment.production ? this.#router.createUrlTree(['/']) : true;
  }
}
